import Chart from "react-apexcharts";
import React from "react";
const TransactionPerformanceSingle = ({ options }) => {
  return (
    <div id="chart">
      <Chart
        series={options.series}
        options={options.options}
        type="bar"
        //height={900}
      />
    </div>
  );
};

export default TransactionPerformanceSingle;
